(function(context) {
    var
        HTML_DATA_ATTRIBUTE_SELECTOR = '[data-display-leaving-website-popup=true]',
        _ENABLE_GLOBAL_LEAVING_WEBSITE_POPUP =
            typeof (context.ENABLE_GLOBAL_LEAVING_WEBSITE_POPUP !== 'undefined')
                ? context.ENABLE_GLOBAL_LEAVING_WEBSITE_POPUP
                : false,
        CRITERIA_CONFIG = {
            SETS: [{type: 'internal'}, {type: 'external'}],
            SETS_BY_TYPE: {}
        };

    CRITERIA_CONFIG.SETS.forEach(function (criteriaConfigSet, i){
        var type = criteriaConfigSet.type;
        criteriaConfigSet.selector = '#leavingWebsitePopupURL' + type[0].toUpperCase() + type.slice(1) + 'Patterns';
        criteriaConfigSet.criteria = criteriaConfigSet.criteriaRegexps = null;
        CRITERIA_CONFIG.SETS_BY_TYPE[type] = criteriaConfigSet;
    });

    new (Marionette.ItemView.extend({
        template: '#leavingVitalityPopup_Tmpl',
        ui: {
            proceedTrigger: '#leavingPopupButtonLink',
            redirectForm: '.redirectForm'
        },
        events: {
            'click @ui.proceedTrigger': 'onProceedTriggerClick',
            'hidden.bs.modal': 'onPopUpHidden',
            'shown.bs.modal': 'onPopUpShown'
        },
        initialize: function() {
            this.model = new (Backbone.Model.extend({
                defaults: {
                    type: null,
                    url: null
                },
            }));
            this.render();
            this.listenTo(this.model, 'change', this.render);
            this.options.$body.on(
                'click',
                _ENABLE_GLOBAL_LEAVING_WEBSITE_POPUP
                    ? 'a'
                    : HTML_DATA_ATTRIBUTE_SELECTOR,
                function(e) {
                    var
                        $el = $(e.currentTarget),
                        isLink = $el.is('[href]'),
                        url = isLink && $el.attr('href'),
                        isViaIndividualAttributeDefinition = isLink && $el.is(HTML_DATA_ATTRIBUTE_SELECTOR);

                    if (this.ui.proceedTrigger.is($el) && ! this.ui.proceedTrigger.is('[data-display-leaving-website-popup-extra-attempt-trigger]')) {
                        return;
                    }

                    if (isLink) {
                        if (_ENABLE_GLOBAL_LEAVING_WEBSITE_POPUP && ! isViaIndividualAttributeDefinition) {

                            if (! this.dynamicLinkCriteriaSetupIsDone) {
                                this.setupDynamicLinkCriteria();
                            }

                            var
                                isExternalLinkAccordingToBackEnd = false,
                                isInternalLinkAccordingToBackEnd = false;

                            isExternalLinkAccordingToBackEnd = this.checkMatchForDynamicCriteriaType(url, 'external'); // not permitted by Back-end

                            if (this._startsWith_CONTEXT_PATH(url) && ! isExternalLinkAccordingToBackEnd) {
                                return;
                            }

                            if (! seemsToBeAnExternalLink(url)) {
                                if (! isExternalLinkAccordingToBackEnd) {
                                    return;
                                }
                            }

                            if (this._freeFromContactProtocols(url)) {
                                return;
                            }

                            if (this._isValidEmail(url)) {
                                return;
                            }

                            isInternalLinkAccordingToBackEnd = this.checkMatchForDynamicCriteriaType(url, 'internal'); // permitted by Back-end

                            if (isInternalLinkAccordingToBackEnd && ! (isInternalLinkAccordingToBackEnd && isExternalLinkAccordingToBackEnd)) {
                                return;
                            }

                            var nonSpecificPopup = true;
                        }

                        if (_ENABLE_GLOBAL_LEAVING_WEBSITE_POPUP && $el.is('[data-display-leaving-website-popup=false]')) {
                            return;
                        }

                        e.preventDefault();

                        var
                            type = $el.data('leaving-portal-action-type'),
                            data = $el.data('leaving-portal-action-serialized-params'),
                            modelProps = _.extend(
                                {
                                    url: url,
                                    type: (typeof type !== 'undefined') ? type : null
                                },
                                typeof nonSpecificPopup !== 'undefined'
                                    ? { nonSpecific: nonSpecificPopup }
                                    : {},
                                typeof data !== 'undefined'
                                    ? { data: data }
                                    : {}
                            );
                        this.model.set(modelProps);
                        this.display(true);

                    }
                }.bind(this)
            );
        },
        setupDynamicLinkCriteria: function (){
            CRITERIA_CONFIG.SETS.forEach(function (criteriaConfigSet, i){
                var meta_json_content_criteria = $(criteriaConfigSet.selector).attr('content');
                try {
                    criteriaConfigSet.criteria = JSON.parse(meta_json_content_criteria);
                } catch(e) {}

                if (! _.isArray(criteriaConfigSet.criteria)) {
                    criteriaConfigSet.criteria = [];
                }

                if (criteriaConfigSet.type === 'internal') {
                    criteriaConfigSet.criteria.push(
                        '^(https?:\/\/|www.)\\S*?' + document.location.host + '\\S*'
                    );
                }

                criteriaConfigSet.criteriaRegexps = [];

                criteriaConfigSet.criteria.forEach(function (regexpCriteria){
                    var regexp;
                    try {
                        regexp = new RegExp(regexpCriteria)
                    } catch(e) {}
                    if (regexp) {
                        criteriaConfigSet.criteriaRegexps.push(regexp);
                    }
                }.bind(this));
            });

            this.dynamicLinkCriteriaSetupIsDone = true;
        },
        checkMatchForDynamicCriteriaType: function (url, type){
            for (var matchFound = false, criteriaRegexps = CRITERIA_CONFIG.SETS_BY_TYPE[type].criteriaRegexps, i = 0; i < criteriaRegexps.length; i++) {
                var regexp = criteriaRegexps[i];
                if (! matchFound && regexp.test(url)) {
                    matchFound = true;
                    break;
                }
            }
            return matchFound;
        },
        _startsWith_CONTEXT_PATH: function (string){
            if (! this.startsWith_CONTEXT_PATH_Regexp) {
                this.startsWith_CONTEXT_PATH_Regexp = new RegExp('^(\/?' + CONTEXT_PATH.replace(/^\/|\/$/g, '') + '\/?\\S*)');
            }
            return this.startsWith_CONTEXT_PATH_Regexp.test(string);
        },
        _freeFromContactProtocols: function (string) {
            if (! this.contactProtocols_Regexp) {
                this.contactProtocols_Regexp = new RegExp('^(?!(?:javascript|data|chrome|mailto|tel|sms|callto|mms|skype):).+$');
            }
            return ! this.contactProtocols_Regexp.test(string);
        },
        _isValidEmail: function (string) {
            if (! this.validEmail_Regexp) {
                this.validEmail_Regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
            }
            return this.validEmail_Regexp.test(string);
        },
        onProceedTriggerClick: function () {
            this.display(false);
            if (this.model.get('type') === 'post-form' && this.ui.redirectForm.length) {
                this.ui.redirectForm.submit();
            }
        },
        onPopUpHidden: function () {
            this.display(false);
            $('.modal:visible').length && this.options.$body.addClass('modal-open');
        },
        onPopUpShown: function (){

        },
        display: function (bool) {
            this.options.$body[((!! bool) ? 'add' : 'remove') + 'Class']('activeLeavingPopup');
            this.$el.modal(!! bool ? 'show' : 'hide');
            var
                $modalBackdrop = $('.modal-backdrop'),
                zIndex = parseInt(2147483647 * 1.1);

            if ($modalBackdrop.length) {
                if (bool) {
                    this.$el
                        .css('z-index', zIndex + 1)
                        .appendTo(this.options.$body);
                }
                else {
                    (! $('.modal:visible').length) && $modalBackdrop.remove();
                }
                $modalBackdrop.css('z-index', (!! bool) ? zIndex : '');
            }
        },
        onRender: function(){
            var $el = this.$el = this.$el.children();
            $el.unwrap();
            this.setElement($el);
            ! this.options.$body.has($el).length && $el.appendTo(this.options.$body);

        }
    }))({$body: $(document.body)});
})(this);
